import { render } from "./AllProductsReportPage.vue?vue&type=template&id=7cbb5abc"
import script from "./AllProductsReportPage.vue?vue&type=script&lang=js"
export * from "./AllProductsReportPage.vue?vue&type=script&lang=js"

import "./AllProductsReportPage.vue?vue&type=style&index=0&id=7cbb5abc&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__